import { Link } from "react-router-dom";
import { useAuth } from "@/client/lib/auth";
import { firstAccessiblePath, type AdminAccess } from "@/client/lib/access";
import { RESOURCE_LABELS, isStaffResource } from "@/shared/permissions";
import { Button } from "@/client/components/ui/button";
import { LockIcon } from "lucide-react";

// Shown when a staff member opens an admin page they have no read rights for. Renders inside the
// AdminShell (the route guard supplies the shell) so the sidebar stays and they keep their bearings.
export function GeenToegang({ resource }: { resource?: AdminAccess }) {
  const { user } = useAuth();
  const roles = user?.roles ?? [];
  const caps = user?.capabilities ?? ({} as any);

  const landing = firstAccessiblePath(roles, caps);
  const toProfile = landing === "/admin/profiel";
  const onderdeel = typeof resource === "string" && isStaffResource(resource) ? RESOURCE_LABELS[resource] : null;

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="max-w-md rounded-lg border bg-card p-8 text-center">
        <span className="mx-auto flex size-12 items-center justify-center rounded-full bg-muted">
          <LockIcon className="size-6 text-muted-foreground" />
        </span>
        <h2 className="mt-4 text-lg font-semibold">Geen toegang tot dit onderdeel</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {onderdeel
            ? `Je hebt nog geen rechten om ${onderdeel} te bekijken.`
            : "Je hebt nog geen rechten om dit onderdeel te bekijken."}{" "}
          Vraag de beheerder om toegang als je deze gegevens nodig hebt.
        </p>
        <Button render={<Link to={landing} />} className="mt-5">
          {toProfile ? "Naar je profiel" : "Naar je startpagina"}
        </Button>
      </div>
    </div>
  );
}
